import { render, staticRenderFns } from "./edit_product.vue?vue&type=template&id=1f106606&"
import script from "./edit_product.vue?vue&type=script&lang=js&"
export * from "./edit_product.vue?vue&type=script&lang=js&"
import style0 from "./edit_product.vue?vue&type=style&index=0&id=1f106606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports